import axios from "../api";

export const createPlanAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/plan/create", data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const updatePlanAction = async (id, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(`/api/plan/update/${id}`, data)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const getPlanByIdAction = async (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/api/plan/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const listAllPlansAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/plan", { params: data })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const listAllPlansDropDownAction = async () => {
  return new Promise((resolve, reject) => {
    axios
      .get("/api/plan/plan-dropdown")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response?.data || error));
  });
};

export const deleteMultiplePlansAction = async (ids) => {
  return new Promise((resolve, reject) => {
    axios
      .put("/api/plan/deleteMultiple", ids)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

export const validatePaymentLinkAction = async (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`/api/plan/validate-link`, data)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updatePlanStatusAction = async (id, data) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/plan/update-plan-status/${id}`, data)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error.response?.data || error);
            });
    });
};